import React, { useEffect, useState } from "react";

// Removed unused motion import

import PageTraiteur from './PageTraiteur';
import PageCatering from './PageCatering';
import PageConcept from './PageConcept';
import PageRestoBingo from './PageRestoBingo';
import PageProducteurices from './PageProducteurices';
import PageProjetsComestibles from './PageProjetsComestibles';
import QuiSuisJe from './QuiSuisJe';
import Infos from './Infos';

import Lenis from "@studio-freight/lenis";
import Credits from "../Credits";
import MenuMobile from "../MenuMobile";
import Newsletters from "./Newsletters";

// Removed unused fadeInOptions

const Home = () => {



    useEffect(() => {
        // Disable Lenis on mobile devices for native scrolling
        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
            if (window.__lenis) {
                try { window.__lenis.destroy(); } catch (_) { }
                delete window.__lenis;
            }
            return;
        }

        const lenis = new Lenis({
            smoothWheel: true,
            wheelMultiplier: 0.8,
            touchMultiplier: 0.8,
        });

        // Expose globally for programmatic navigation
        if (typeof window !== 'undefined') {
            window.__lenis = lenis;
        }

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            if (typeof window !== 'undefined' && window.__lenis === lenis) {
                delete window.__lenis;
            }
        };
    }, []);

    return <>
        <PageConcept />
        <QuiSuisJe />
        <PageTraiteur />
        <PageCatering />
        <PageRestoBingo />
        <PageProjetsComestibles />
        <PageProducteurices />
        <Infos />
        <Newsletters />



    </>
};

export default Home;